import { instance } from './index';

// Check Dashboard Admin access
function getAdminHome() {
  return instance.get('admin/home');
}

// Get company summaries
function getCompanySummary(queries) {
  return instance.get('admin/companies', queries);
}

// Get company detail
function getCompanyDetail(companyId) {
  return instance.get(`admin/companies/${companyId}`);
}

// Update company payment plan
function updateCompanyPaymentPlan(companyId, data) {
  return instance.put(`admin/companies/${companyId}/plan`, data);
}

// get company history logs
function getCompanyHistory(companyId, queries) {
  return instance.get(`admin/companies/${companyId}/history`, queries);
}

// get company report
function getCompanyReport(companyId, queries) {
  return instance.get(`admin/companies/${companyId}/report`, queries);
}

// get company metrics for csv export
function getCompanyMetrics(companyId, queries) {
  return instance.get(`admin/companies/${companyId}/export`, queries);
}

// Get Company Note List
function getCompanyNoteList(companyId, lastTimestamp, limit) {
  return instance.get(`admin/companies/${companyId}/notes?lastTimestamp=${lastTimestamp}&limit=${limit}`);
}

// Create New Company Note
function createNewCompanyNote(companyId, message) {
  return instance.post(`admin/companies/${companyId}/notes`, {
    text: message,
  });
}

// Update Company Note
function updateCompanyNote(companyId, noteId, message) {
  return instance.post(`admin/companies/${companyId}/notes/${noteId}`, {
    text: message,
  });
}

// Delete Company Note
function deleteCompanyNote(companyId, noteId) {
  console.log('delete', noteId);
  return instance.delete(`admin/companies/${companyId}/notes/${noteId}`);
}

// Get Company Invoice List
function getCompanyInvoiceList(companyId, lastInvoiceId, limit) {
  return instance.get(`admin/companies/${companyId}/invoice?lastInvoiceId=${lastInvoiceId}&limit=${limit}`);
}

// Get Dashboard Super User candidates
function getSuperUserCandidates(queries) {
  return instance.get('admin/super-user/candidates', queries);
}

// Grant Dashboard Super User permission
function grantSuperUser(data) {
  return instance.post('admin/super-user/grant', data);
}

// Revoke Dashboard Super User permission
function revokeSuperUser(data) {
  return instance.post('admin/super-user/revoke', data);
}

// Get Dashboard announcements
function getAnnouncements(queries) {
  return instance.get('admin/announcements', queries);
}

// Get Dashboard announcement detail
function getAnnouncement(announcementId) {
  return instance.get(`admin/announcements/${announcementId}`);
}

// Create Dashboard announcement
function createAnnouncement(data) {
  return instance.post('admin/announcements', data);
}

// Update Dashboard announcement
function updateAnnouncement(announcementId, data) {
  return instance.put(`admin/announcements/${announcementId}`, data);
}

export default {
  getAdminHome,
  getCompanySummary,
  getCompanyDetail,
  updateCompanyPaymentPlan,
  getCompanyHistory,
  getCompanyReport,
  getCompanyMetrics,
  getCompanyNoteList,
  createNewCompanyNote,
  updateCompanyNote,
  deleteCompanyNote,
  getCompanyInvoiceList,
  getSuperUserCandidates,
  grantSuperUser,
  revokeSuperUser,
  getAnnouncements,
  getAnnouncement,
  createAnnouncement,
  updateAnnouncement,
};
